<div class="flex flex-row w-full h-[75vh] baselayout-padding baselayout-padding-t items-stretch justify-between">
  <div class="flex flex-col w-[30vw] h-full justify-between gap-4">
    <div class="flex flex-row w-full min-h-[25vh] justify-between gap-4">
      <app-card-with-header
      [hasHeader]="true"
      [hasFooter]="true"
      >
        <div header>
          {{ 'PetDetails.PetDetails'|translate }}
        </div>
        <div headerActions>
          <i class="self-end pi pi-pen-to-square clickable" (click)="openEditPetPage()"></i>
        </div>
        <div>
          <div class="grid grid-rows-3 grid-cols-2 h-full gap-y-2">
            <div class="row-start-1 col-start-1">
              {{ 'Pet.Race'|translate }}
            </div>
            <div class="row-start-1 col-start-2">
              {{ pet?.race }}
            </div>
            <div class="row-start-2 col-start-1">
              {{ 'Pet.Age'|translate }}
            </div>
            <div class="row-start-2 col-start-2">
              {{ getAge(pet?.dateOfBirth) }}
            </div>
            <div class="row-start-3 col-start-1">
              {{ 'Pet.Gender'|translate }}
            </div>
            <div class="row-start-3 col-start-2">
              {{ getGender(pet?.gender) }}
            </div>
          </div>
        </div>
        <div footer>
          <p class="clickable text-primary"
             (click)="openPetDetailWidget(pet)">{{ "PetDetails.ShowMore"|translate }}</p>
        </div>
      </app-card-with-header>
      <app-card-with-header>
        <div header>
          {{ 'PetDetails.Skeleton'|translate }}
        </div>
        <div>
          @if (pet) {
            <div class="flex-grow flex items-center justify-center overflow-hidden relative h-[15vh]">
              <div class="imageContainer h-full w-full flex items-center justify-center">
                <img class="max-w-full max-h-full object-contain"
                     [src]="`img/${pet?.species?.toLowerCase()}_left.svg`"/>
                <div class="imageContainerCenterIcon">
                  <i class="pi pi-eye text-center text-white clickable" style="font-size: 24px"
                     (click)="openViewSkeletonDialog()"></i>
                </div>
                <div class="imageContainerBottomLeftIcon">
                  <i class="material-symbols-outlined text-white clickable"
                     (click)="openEditSkeletonPage()">edit</i>
                </div>
                @if (hasSkeletonAnnotation(pet)) {
                  <div class="imageContainerBottomRightIcon">
                    <i class="material-symbols-outlined text-white">format_ink_highlighter</i>
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </app-card-with-header>
    </div>

    <div class="w-full h-full">
      <app-card-with-tabs
        [selectedTab]="selectedBehaviourAnamnesisTab"
        [leftTabHeader]="'PetDetails.Anamnesis'|translate"
        [rightTabHeader]="'PetDetails.Behavior'|translate"
        [hasFooter]="true"
      >
        <div leftTabContent>
          <div class="flex flex-col w-full h-full p-2">
            <app-greedy-scroll-panel>
              @if (pet?.anamnesis) {
                <div class=" whitespace-pre-line textbox" [innerHTML]="pet?.anamnesis??''|safeHtml"></div>
              } @else {
                <div class=" whitespace-pre-line textbox">{{ 'PetDetails.NoAnamnesis'|translate }}</div>
              }
            </app-greedy-scroll-panel>
          </div>
        </div>
        <div leftTabFooter>
          <i class="self-end pi pi-pen-to-square clickable mt-2" (click)="openEditPetPage()"></i>
        </div>
        <div rightTabContent>
          <div class="flex flex-col w-full h-full">
            <div class="flex flex-row gap-4 h-full">
              <div class="flex flex-col justify-center items-center gap-2">
                <span class="bg-red-400 rounded-full w-6 h-6"
                      [ngClass]="estimateHighDangerClassActive(pet)"></span>
                <span class="bg-yellow-400 rounded-full w-6 h-6"
                      [ngClass]="estimateMediumDangerClassActive(pet)"></span>
                <span class="bg-green-400 rounded-full w-6 h-6"
                      [ngClass]="estimateLowDangerClassActive(pet)"></span>
                <span class="bg-pink-400 rounded-full w-6 h-6"
                      [ngClass]="estimatePerfectlySafeClassActive(pet)"></span>
              </div>
              <app-greedy-scroll-panel>
                @if (pet?.behaviorText) {
                  <div class=" whitespace-pre-line textbox" [innerHTML]="pet?.behaviorText??''|safeHtml"></div>
                } @else {
                  <div class=" whitespace-pre-line textbox">
                    {{ GetBehaviorText(pet?.behavior ?? "Unknown")|translate }}
                  </div>
                }
              </app-greedy-scroll-panel>
            </div>
          </div>
        </div>
        <div rightTabFooter>
          <i class="self-end pi pi-pen-to-square clickable" (click)="openEditPetPage()"></i>
        </div>
      </app-card-with-tabs>
    </div>
  </div>
  <div class="flex flex-col w-[25vw] h-full">
    <app-attachment-gallery
      class="w-full h-full"
      [pinnedDocuments]="pinnedDocuments"
      [notPinnedDocuments]="notPinnedDocuments"
      [pinnedImages]="pinnedImages"
      [notPinnedImages]="notPinnedImages"
      [hasImages]="true"
      [hasDocuments]="true"
      (onPinDocument)="pinDocument($event)"
      (onUnpinDocument)="unpinDocument($event)"
      (onDeleteDocument)="openDeleteDocumentDialog($event)"
      (onViewDocument)="openViewDocumentDialog($event)"
      (onAddDocument)="openAddDocumentDialog($event)"
      (onEditDocument)="openEditDocumentPage($event)"
      [selectedTab]="selectedImagesDocumentTab"
    ></app-attachment-gallery>
  </div>
  <div class="flex flex-col w-[25vw] h-full items-center justify-start gap-4">
    <app-card-with-header class="w-full h-full"
                          [hasHeader]="true"
    >
      <div header>
        {{ 'PetDetails.PlannedTreatments'|translate }}
      </div>
      <div headerActions>
        <p-button icon="pi pi-plus" [rounded]="true" (click)="openAddTreatmentPage()"/>
      </div>
      <div class="flex flex-col h-full">
        <div class="w-full mt-2 flex flex-col px-5 pb-5">
          @if (plannedTreatments.length == 0) {
            <div class="font-bold text-gray-500">
              {{ ('PetDetails.NoPlannedTreatments'|translate) }}
            </div>
          } @else {
            <div class="min-h-0 h-[9rem]">
            <app-greedy-scroll-panel>
            @for (treatment of this.plannedTreatments; track treatment.id) {
              <div class="flex flex-row items-center my-2 gap-2">
                <p-button [routerLink]="'../../treatment-detail/'+treatment.id">
                  <span class="material-icons !text-[16px]">event</span>
                </p-button>
                <div class="font-bold">
                  {{ `${getDateAndTime(treatment.appointmentDate)} - ${treatment.title}` }}
                </div>
              </div>
            }
            </app-greedy-scroll-panel>
            </div>
          }
        </div>
        <span class="mb-[0.625rem] text-2xl font-normal">
        {{ 'PetDetails.PastTreatments'|translate }}
      </span>
        <div class="flex-1 min-h-0">
          <app-greedy-scroll-panel>
            <div class="w-full flex-1 min-h-0 px-5 overflow-y-auto">
              @if (pastTreatments.length == 0) {
                <div class="font-bold text-gray-500 py-5">
                  {{ ('PetDetails.NoPastTreatments'|translate) }}
                </div>
              } @else {
                <div class="pb-5">
                  @for (treatment of this.pastTreatments; track treatment.id) {
                    <div class="flex flex-row items-center my-2 gap-2">
                      <p-button [routerLink]="'../../treatment-detail/'+treatment.id">
                        <span class="material-icons !text-[16px]">event</span>
                      </p-button>
                      <div class="font-bold">
                        {{ `${getDate(treatment.appointmentDate)} - ${treatment.title}` }}
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          </app-greedy-scroll-panel>
        </div>
      </div>
    </app-card-with-header>
  </div>
</div>
